import { render, staticRenderFns } from "./gmindex.vue?vue&type=template&id=e54720ac&scoped=true&"
import script from "./gmindex.vue?vue&type=script&lang=js&"
export * from "./gmindex.vue?vue&type=script&lang=js&"
import style0 from "./gmindex.vue?vue&type=style&index=0&id=e54720ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54720ac",
  null
  
)

export default component.exports